export const START_APP_LOADING = 'START_APP_LOADING'
export const STOP_APP_LOADING = 'STOP_APP_LOADING'
export const SET_SCROLL_MOVE_Y = 'SET_SCROLL_MOVE_Y'
export const SET_HISTORY_KEYWORDS = 'SET_HISTORY_KEYWORDS'
